import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {ModuleModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function getModuleByIdService(id: string | undefined | number) {
  return await axios.get<ResponseObject<ModuleModel>>(`${BASEURL}/module/getModuleById`, {
    params: {
      Id: id,
    },
  })
}
